/* 4Women — Quick-add del abrigo en la zona de compra del conjunto.
 *
 * Mismo motivo que fw-packs.js: inline no sobrevivia al morph del quick-add de
 * coleccion. Delega sobre document, asi que una carga alcanza.
 */
(() => {
  if (window.__fwAbrigoQA) return;
  window.__fwAbrigoQA = true;

  document.addEventListener('click', async (ev) => {
    const pill = ev.target instanceof Element && ev.target.closest('.fw-abq__t');
    if (!pill || pill.disabled || pill.classList.contains('is-cargando')) return;

    /* Repetir la misma talla no debe sumar otra unidad por accidente. */
    if (pill.classList.contains('is-agregada')) return;

    const raiz = pill.closest('fw-abrigo-qa');
    const nota = raiz.querySelector('[data-estado]');
    pill.classList.add('is-cargando');

    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(pill.dataset.vid), quantity: 1 }] }),
      });
      if (!r.ok) throw new Error('HTTP ' + r.status);

      pill.classList.remove('is-cargando');
      pill.classList.add('is-agregada');
      nota.classList.add('is-ok');
      nota.textContent = 'En tu carrito. Agrega tu conjunto y el descuento entra solo.';

      /* Refresca la burbuja sin abrir el cajon: la clienta todavia no
         agrego el conjunto y abrirle el carrito ahora la interrumpe justo
         antes de la accion principal. */
      try {
        const carrito = await (await fetch('/cart.js')).json();
        document.querySelectorAll('.cart-bubble__text-count').forEach((b) => {
          b.textContent = carrito.item_count;
        });
        document.querySelectorAll('cart-icon-component .cart-bubble[hidden]').forEach((b) => {
          b.hidden = false;
        });
      } catch (e) { /* la burbuja se corrige sola en la proxima navegacion */ }
    } catch (e) {
      pill.classList.remove('is-cargando');
      nota.textContent = 'No se pudo agregar. Intenta de nuevo.';
    }
  });
})();
